import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProjectListPage from "./components/company/projects/pages/index/ProjectListPage";
import ProjectsCreateForm from "./components/company/projects/pages/create/ProjectsCreateForm";
import ProjectDetailPage from "./components/company/projects/pages/show/ProjectDetailPage";
import ProjectEditForm from "./components/company/projects/pages/edit/ProjectEditForm";
import JobListPage from "./components/company/jobs/pages/index/JobListPage";
import JobsCreateForm from "./components/company/jobs/pages/create/JobsCreateForm";
import JobDetailPage from "./components/company/jobs/pages/show/JobDetailPage";
import JobEditForm from "./components/company/jobs/pages/edit/JobEditForm";
import UserProjectListPage from "./components/user/projects/pages/index/ProjectListPage";
import UserProjectDetailPage from "./components/user/projects/pages/show/ProjectDetailPage";
import UserJobListPage from "./components/user/jobs/pages/index/JobListPage";
import UserJobDetailPage from "./components/user/jobs/pages/show/JobDetailPage";
import CompanyCandidatesListPage from "./components/company/candidates/pages/index/CompanyCandidatesListPage";
import CompanyUserContractRequestPage from "./components/company/candidates/pages/show/CompanyUserContractRequestPage";
import CompanyUserJobRequestPage from "./components/company/candidates/pages/show/CompanyUserJobRequestPage";
import MemberListPage from "./components/company/members/pages/index/MemberListPage";
import Mypage from "./components/company/mypage/Mypage";
import CompanyInfo from "./components/company/info/CompanyInfo";
import CompanyUsers from "./components/company/users/CompanyUsers";
import SettingEditForm from "./components/company/settings/pages/edit/SettingEditForm";

// React Router を使ってルーティングを定義するコンポーネント
const AppRouter = ({ flashMessage, currentUser, csrfToken }) => (
  <BrowserRouter>
    <Routes>
      {/* --- 企業側ルート --- */}
      {/* 会社情報 */}
      <Route path="/mypage" element={<Mypage currentUser={currentUser} csrfToken={csrfToken} flashMessage={flashMessage} />}>
        <Route index element={<CompanyInfo csrfToken={csrfToken} />} />
      </Route>

      {/* 担当者 */}
      <Route path="/company/users" element={<Mypage currentUser={currentUser} csrfToken={csrfToken} flashMessage={flashMessage} />}>
        <Route index element={<CompanyUsers currentUser={currentUser} csrfToken={csrfToken} flashMessage={flashMessage} />} />
      </Route>

      {/* 設定 */}
      <Route path="/company/settings/edit" element={<Mypage currentUser={currentUser} csrfToken={csrfToken} flashMessage={flashMessage} />}>
        <Route index element={<SettingEditForm />} />
      </Route>

      {/* プロジェクト */}
      <Route path="/company/projects" element={<Mypage currentUser={currentUser} csrfToken={csrfToken} flashMessage={flashMessage} />}>
        <Route index element={<ProjectListPage flashMessage={flashMessage} />} />
        <Route path="new" element={<ProjectsCreateForm currentUser={currentUser} csrfToken={csrfToken} />} />
        <Route path=":id" element={<ProjectDetailPage />} />
        <Route path=":id/edit" element={<ProjectEditForm currentUser={currentUser} csrfToken={csrfToken} />} />
      </Route>

      {/* 求人 */}
      <Route path="/company/jobs" element={<Mypage currentUser={currentUser} csrfToken={csrfToken} flashMessage={flashMessage} />}>
        <Route index element={<JobListPage />} />
        <Route path="new" element={<JobsCreateForm currentUser={currentUser} csrfToken={csrfToken} />} />
        <Route path=":id" element={<JobDetailPage />} />
        <Route path=":id/edit" element={<JobEditForm currentUser={currentUser} csrfToken={csrfToken} />} />
      </Route>

      {/* 人材・候補者 */}
      <Route path="/company/candidates" element={<Mypage currentUser={currentUser} csrfToken={csrfToken} flashMessage={flashMessage} />}>
        <Route index element={<CompanyCandidatesListPage />} />
        <Route path=":id/contract_request" element={<CompanyUserContractRequestPage />} />
        <Route path=":id/job_request" element={<CompanyUserJobRequestPage />} />
      </Route>

      {/* メンバー管理 */}
      <Route path="/company/members" element={<Mypage currentUser={currentUser} csrfToken={csrfToken} flashMessage={flashMessage} />}>
        <Route index element={<MemberListPage flashMessage={flashMessage} />} />
      </Route>

      {/* --- ユーザー側ルート --- */}
      <Route path="/projects" element={<UserProjectListPage csrfToken={csrfToken} />} />
      <Route path="/projects/:id" element={<UserProjectDetailPage csrfToken={csrfToken} />} />
      <Route path="/jobs" element={<UserJobListPage csrfToken={csrfToken} />} />
      <Route path="/jobs/:id" element={<UserJobDetailPage csrfToken={csrfToken} />} />
    </Routes>
  </BrowserRouter>
);


export default AppRouter;
